<ds-modal [modalInput]="startupModalConfig">
  <ng-container modal-body>
      <div class="--status --primary no-bullet text-info">{{ 'new_onb_startup_free_preview_badge' | translate:{ days: basicFunctionTrialDays } }}</div>
      <h6 class="title-24">{{ 'new_onb_startup_title' | translate }} <span class="text-info">{{ 'new_onb_startup_title_highlight' | translate }}</span></h6>
      <p class="paragraph-12">{{ 'new_onb_startup_subtitle' | translate }}</p>
      <div class="white-info-container gap-12">
        <div class="d-flex gap-8 align-items-start">
          <div class="icon-box --large-img --success-subtle"><img [src]="ICONS.BILL" alt=""></div>
          <div>
            <h6 class="title-14">{{ 'new_onb_startup_submit_claim_title' | translate }}</h6>
            <p class="paragraph-12">{{ 'new_onb_startup_submit_claim_desc' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="white-info-container gap-12">
        <div class="d-flex gap-8 align-items-start">
          <div class="icon-box --large-img --primary-subtle"><img [src]="ICONS.PIE_CHART" alt=""></div>
          <div>
            <h6 class="title-14">{{ 'new_onb_startup_explore_dashboard_title' | translate }}</h6>
            <p class="paragraph-12">{{ 'new_onb_startup_explore_dashboard_desc' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="white-info-container gap-12">
        <div class="d-flex gap-8 align-items-start">
          <div class="icon-box --large-img --secondary-subtle"><img [src]="ICONS.USER" alt=""></div>
          <div>
            <h6 class="title-14">{{ 'new_onb_startup_full_platform_title' | translate }}</h6>
            <p class="paragraph-12">{{ 'new_onb_startup_full_platform_desc' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column gap-10 align-items-center justify-content-center">
        <ds-button [buttonInput]="continueButtonConfig" (click)="fnOnContinue()"></ds-button>
        <p class="paragraph-14 text-placeholder">{{ 'new_onb_startup_no_credit_card' | translate }}</p>
      </div>
  </ng-container>
</ds-modal>